import { render, staticRenderFns } from "./main-dashboard.vue?vue&type=template&id=6fa3d666&scoped=true&"
import script from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./main-dashboard.scss?vue&type=style&index=0&id=6fa3d666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa3d666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa3d666')) {
      api.createRecord('6fa3d666', component.options)
    } else {
      api.reload('6fa3d666', component.options)
    }
    module.hot.accept("./main-dashboard.vue?vue&type=template&id=6fa3d666&scoped=true&", function () {
      api.rerender('6fa3d666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/milk-run-v2/main-dashboard/main-dashboard.vue"
export default component.exports